var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.564,
    height: 20,
    viewBox: "0 0 16.564 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M136.374-894.625a1.9,1.9,0,0,0,1.4-.583,1.923,1.923,0,0,0,.578-1.4,1.9,1.9,0,0,0-.583-1.4,1.923,1.923,0,0,0-1.4-.578,1.9,1.9,0,0,0-1.4.583,1.923,1.923,0,0,0-.578,1.4,1.9,1.9,0,0,0,.583,1.4A1.923,1.923,0,0,0,136.374-894.625Zm0,6.12a26.67,26.67,0,0,0,4.137-4.3,6.539,6.539,0,0,0,1.44-3.832,5.425,5.425,0,0,0-1.6-3.942,5.345,5.345,0,0,0-3.977-1.632,5.343,5.343,0,0,0-3.977,1.632,5.426,5.426,0,0,0-1.6,3.942,6.489,6.489,0,0,0,1.44,3.82A27.688,27.688,0,0,0,136.369-888.5Zm0,3.592a35.53,35.53,0,0,1-6.245-6.182,9.332,9.332,0,0,1-2.037-5.539,8.2,8.2,0,0,1,2.331-5.8,7.8,7.8,0,0,1,5.94-2.477,7.837,7.837,0,0,1,5.951,2.477,8.173,8.173,0,0,1,2.342,5.8,9.322,9.322,0,0,1-2.025,5.529,35.542,35.542,0,0,1-6.257,6.193ZM136.369-896.608Z",
    transform: "translate(-128.087 904.913)",
    fill: "var(--primary-color)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7feaecce300d7331d0a75a979c7dd144.svg";
export { ForwardRef as ReactComponent };